import React from 'react';

const StretchText = (props) => {

    return (
        <svg viewBox="0 0 10 10" style={{ width: "100%" }}>
            <text x="0" y="0">{props.text}</text>
        </svg>
    );
}

export default StretchText;